import { EventEmitter, Injectable } from '@angular/core';
import { HttpHandlerService } from './http-handler.service';
import { AuthorizationService } from './authorization.service';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

interface User {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})

export class EconomicTestService {

  errorTokenMessage = 'Your token has expired please go back to launchpad'
  errorMessage = 'We had a problem. Please try again in a few minutes'

  constructor(private httpService: HttpHandlerService, private authorizationService: AuthorizationService,) { }

  //  async getAllIpUsers(url: string): Promise<any> {
  //   console.log("@@@@getAllIpUsers", url)
    // const res: any = this.httpService.get(url)
    // if (res.status == 403) {
    //   if (this.authorizationService.isLoggedInNewClientId() == true)
    //     this.setError.emit(this.errorMessage)
    //   else
    //     this.setError.emit(this.errorTokenMessage)
    // }
    // return res
    // return await firstValueFrom(this.httpService.get(url));
  // }


  //  async getAllIpUsers(url: string) {
  //   console.log("@@@@getAllIpUsers", url)
  //   // @ts-ignore
  //    await this.httpService.get(url)
  //     .subscribe(
  //       (response: any) => {
  //         if (response.status == 403) {
  //           if (this.authorizationService.isLoggedInNewClientId() == true)
  //             this.setError.emit(this.errorMessage)
  //           else this.setError.emit(this.errorTokenMessage)
  //         }
  //         console.log("response ", response)
  //         return response

  //       },
  //       (error: any) => {
  //         // Handle error
  //         console.error('Error:', error);
  //       }
  //     );
  // }

 getAllIp(url: string) {
    const res: any = this.httpService.get(url)
    if (res.status == 403) {
      if (this.authorizationService.isLoggedInNewClientId() == true)
        this.setError(this.errorMessage)
      else
        this.setError(this.errorTokenMessage)

    }
    return res 
  }

  getTableData(url: string, params) {
    const res: any =  this.httpService.post(url, { params: params })
    if (res.status == 403) {
      if (this.authorizationService.isLoggedInNewClientId() == true)
        this.setError(this.errorMessage)
      else
        this.setError(this.errorTokenMessage)
    }
    return res
  }

  setError(errorMessage){
     Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: errorMessage,
                    });
  }
}
